import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconClose = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 23.813 23.906'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M13.305,11.946 L23.521,22.201 C23.909,22.590 23.909,23.221 23.521,23.610 C23.328,23.804 23.074,23.901 22.820,23.901 C22.566,23.901 22.312,23.804 22.118,23.610 L11.901,13.355 L1.685,23.610 C1.492,23.804 1.238,23.901 0.984,23.901 C0.730,23.901 0.476,23.804 0.282,23.610 C-0.106,23.221 -0.106,22.590 0.282,22.201 L10.498,11.946 L0.282,1.692 C-0.106,1.303 -0.106,0.672 0.282,0.283 C0.670,-0.106 1.298,-0.106 1.685,0.283 L11.901,10.537 L22.117,0.283 C22.505,-0.106 23.133,-0.106 23.521,0.283 C23.908,0.672 23.908,1.303 23.521,1.692 L13.305,11.946 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconClose.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
